document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const navToggle = document.querySelector('[data-nav-toggle]');

  if (header && navToggle) {
    navToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantSelect = root.querySelector('[data-variant-select]');
    const priceNode = root.querySelector('[data-product-price]');
    const editionBadge = root.querySelector('[data-edition-badge]');
    const variantNote = root.querySelector('[data-variant-note]');
    const certificateCopy = root.querySelector('[data-certificate-copy]');
    const addToCartButton = root.querySelector('[data-add-to-cart]');

    if (!variantSelect || !priceNode || !editionBadge || !variantNote || !certificateCopy || !addToCartButton) {
      return;
    }

    const openCertificate = root.dataset.openCertificate || '';
    const limitedCertificate = root.dataset.limitedCertificate || '';

    /* ── Render variant state (price, badge, button) ── */

    const renderVariantState = () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;

      const available = option.dataset.available === 'true';
      const inventory = Number(option.dataset.inventory || 0);
      const isLimited = option.dataset.limited === 'true';
      const editionSize = editionBadge.dataset.editionSize;
      const compareAt = option.dataset.compareAt;

      let badgeText = 'Open edition';
      let badgeMeta = '';

      if (isLimited && !available) {
        badgeText = 'Sold out';
      } else if (isLimited && inventory > 0 && inventory <= 3) {
        badgeText = 'Low availability';
      } else if (isLimited) {
        badgeText = 'Limited edition available';
      }

      if (isLimited && editionSize) {
        badgeMeta = `Edition of ${editionSize}`;
      }

      priceNode.innerHTML = `
        <span class="product-price__current">${option.dataset.price || ''}</span>
        ${compareAt ? `<span class="product-price__compare">${compareAt}</span>` : ''}
      `;

      editionBadge.innerHTML = `
        <span>${badgeText}</span>
        ${badgeMeta ? `<small>${badgeMeta}</small>` : ''}
      `;

      variantNote.textContent = option.dataset.signedLabel || '';
      certificateCopy.textContent = isLimited ? limitedCertificate : openCertificate;
      addToCartButton.disabled = !available;
      addToCartButton.textContent = available ? 'Add to cart' : 'Sold out';
    };

    variantSelect.addEventListener('change', renderVariantState);

    /* ── Format configurator (ratio tabs + format grid) ── */

    const ratioTabs = root.querySelectorAll('[data-ratio-tab]');
    const formatRows = root.querySelectorAll('[data-format-row]');
    const formatRadios = root.querySelectorAll('[data-format-radio]');

    if (ratioTabs.length > 0) {
      ratioTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const ratio = tab.dataset.ratioTab;

          ratioTabs.forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-pressed', String(t === tab));
          });

          formatRows.forEach((row) => {
            const isMatch = row.dataset.ratio === ratio;
            row.classList.toggle('is-hidden', !isMatch);
          });

          const firstVisible = root.querySelector(`[data-format-row][data-ratio="${CSS.escape(ratio)}"]:not(.is-hidden) [data-format-radio]`);
          if (firstVisible && !firstVisible.checked) {
            firstVisible.checked = true;
            firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      formatRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          variantSelect.value = radio.value;
          variantSelect.dispatchEvent(new Event('change'));

          formatRows.forEach((row) => {
            row.classList.toggle('is-active', row.contains(radio));
          });
        });
      });
    }

    /* ── Fallback: button-based option picker (single-option products) ── */

    const optionButtons = root.querySelectorAll('[data-option-position]');

    if (optionButtons.length > 0 && ratioTabs.length === 0) {
      const findMatchingVariant = () => {
        const selected = {};
        root.querySelectorAll('[data-option-position].is-active').forEach((btn) => {
          selected[`option${btn.dataset.optionPosition}`] = btn.dataset.optionValue;
        });

        const options = variantSelect.options;
        for (let i = 0; i < options.length; i++) {
          const opt = options[i];
          let match = true;
          for (const key in selected) {
            if (opt.dataset[key] !== selected[key]) {
              match = false;
              break;
            }
          }
          if (match) return opt;
        }
        return null;
      };

      optionButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const position = btn.dataset.optionPosition;
          root.querySelectorAll(`[data-option-position="${position}"]`).forEach((sibling) => {
            sibling.classList.remove('is-active');
            sibling.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          const match = findMatchingVariant();
          if (match) {
            variantSelect.value = match.value;
            variantSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    }

    renderVariantState();

    /* ── Image gallery thumbnails ── */

    const mediaFrames = root.querySelectorAll('[data-media-frame]');
    const mediaThumbs = root.querySelectorAll('[data-media-thumb]');

    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const targetId = thumb.dataset.mediaTarget;

        mediaFrames.forEach((frame) => {
          frame.classList.toggle('is-active', frame.dataset.mediaId === targetId);
        });

        mediaThumbs.forEach((node) => {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    });
  });
});
